import { useNavigate, useParams } from 'react-router-dom'
import './GenrePageOne.scss'
import { movieApi } from '../../redux/services/movieApi'
import { firstLetterBig } from '../../utils/utils'
import { LoaderTopMovie } from '../../ui/LoaderTopMovie/LoaderTopMovie'
import { GenreOneItem } from '../../components/GenreOneItem/GenreOneItem'
import { useEffect, useState } from 'react'
import { IMovies } from '../../models/IMovies'

export const GenrePageOne = () => {

    const { genreName } = useParams()
    const genreNameSafe = genreName || ""
    const back = useNavigate()
    const itemsPerPage = 10;

    const [page, setPage] = useState(1); // Текущая страница
    const [movies, setMovies] = useState<IMovies[]>([]); // Массив отображаемых фильмов
    const [hasMore, setHasMore] = useState(true); // Есть ли еще фильмы для загрузки

    const { data: moviesFilterGenre, isLoading, error, refetch } = movieApi.useGetMoviesQuery({ page: page, count: itemsPerPage, genre: genreNameSafe })

    useEffect(() => {
        if (moviesFilterGenre) {
            setMovies((prevMovies) => [...prevMovies, ...moviesFilterGenre]);
            if (moviesFilterGenre.length < itemsPerPage) {
                setHasMore(false);
            }
        }
    }, [moviesFilterGenre, itemsPerPage]);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop + 100 >=
                document.documentElement.offsetHeight &&
                hasMore &&
                !isLoading
            ) {
                setPage((prevPage) => prevPage + 1);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isLoading, hasMore]);

    const handleRetry = () => {
        setPage(1);
        setMovies([]);
        setHasMore(true);
        refetch();
    };

    const handlerTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      };


    return (
        <section className='genre-page'>
            <div className='container'>
                <button className='title-min' onClick={() => back('/genres')}>{`< ${firstLetterBig(genreNameSafe)}`}</button>
                {isLoading && page === 1 && <LoaderTopMovie />}
                {error &&
                    <div>
                        <h2 style={{ marginBottom: "10px" }}> Произошла ошибка</h2> <button className='btn btn-dark' onClick={handleRetry}>Обновить список</button>
                    </div>}
                <ul className='genre-page__list'>
                    {movies.map((movieFilterGenre) => (
                        <li className='genre-page__item' key={movieFilterGenre.id}>
                            <GenreOneItem movieFilterGenre={movieFilterGenre} />
                        </li>
                    ))}
                </ul>
                {isLoading && page > 1 && <div>Загрузка...</div>}
                {!hasMore && <div className='genre-page__end'>Конец списка перейти в <button className='genre-page__top' onClick={handlerTop}>начало списка</button></div>}
            </div>
        </section>
    )
}